import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { EntityDTO } from '../DocumentVault.meta';
import { queryKeys } from './queryKeys';

interface RenameEntityParams {
  clientId: string;
  objectPath: string;
  newName: string;
}

const renameEntity = ({ clientId, objectPath, newName }: RenameEntityParams): Promise<EntityDTO> => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/RenameObject', {
      clientId,
      objectPath,
      newName,
    }),
    { method: 'POST' },
  );
};

export const useRenameEntityMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(renameEntity, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.listDocumentVaultEntities());
    },
  });
};
